import { Route } from '@angular/router';
import { PostDatatableType } from '@app/src/app/modules/post/classes/default/datatable/post.datatable.type';
import { PostCategoryDatatableType } from '@app/src/app/modules/post/classes/category/datatable/post.category.datatable.type';
import { DashboardGlobalConfigType } from '@ckmk/angular';
import { PostGuard } from '@app/src/app/modules/post/classes/default/guard/post-guard';
import { PostCategoryGuard } from '@app/src/app/modules/post/classes/category/guard/post-category-guard';

export default (config: DashboardGlobalConfigType): Route => ({
  path: 'posts',
  providers: [PostDatatableType, PostCategoryDatatableType],
  children: [
    {
      path: '',
      redirectTo: 'list',
      pathMatch: 'full',
    },
    {
      path: 'list',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/admin/default/post-list/post-list.component').then(
          (m) => m.PostListComponent,
        ),
      data: {
        permissions: ['PERMISSION_READ_POST'],
      },
    },
    {
      path: 'show/:post',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/admin/default/post-show/post-show.component').then(
          (m) => m.PostShowComponent,
        ),
      data: {
        permissions: ['PERMISSION_READ_POST'],
      },
      canActivate: [PostGuard(config)],
    },
    {
      path: 'create',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/admin/default/post-manage/post-manage.component').then(
          (m) => m.PostManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_CREATE_POST'],
      },
    },
    {
      path: 'update/:post',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/admin/default/post-manage/post-manage.component').then(
          (m) => m.PostManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_UPDATE_POST'],
      },
      canActivate: [PostGuard(config)],
    },
    {
      path: 'copy/:post',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/admin/default/post-manage/post-manage.component').then(
          (m) => m.PostManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_COPY_POST'],
      },
      canActivate: [PostGuard(config)],
    },
    {
      path: 'categories',
      children: [
        {
          path: '',
          redirectTo: 'list',
          pathMatch: 'full',
        },
        {
          path: 'list',
          loadComponent: () =>
            import('@app/src/app/modules/post/views/admin/category/category-list/post-category-list.component').then(
              (m) => m.PostCategoryListComponent,
            ),
          data: {
            permissions: ['PERMISSION_READ_POST_CATEGORY'],
          },
        },
        {
          path: 'show/:category',
          loadComponent: () =>
            import('@app/src/app/modules/post/views/admin/category/category-show/post-category-show.component').then(
              (m) => m.PostCategoryShowComponent,
            ),
          data: {
            permissions: ['PERMISSION_READ_POST_CATEGORY'],
          },
          canActivate: [PostCategoryGuard(config)],
        },
        {
          path: 'create',
          loadComponent: () =>
            import('@app/src/app/modules/post/views/admin/category/category-manage/post-category-manage.component').then(
              (m) => m.PostCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_CREATE_POST_CATEGORY'],
          },
        },
        {
          path: 'update/:category',
          loadComponent: () =>
            import('@app/src/app/modules/post/views/admin/category/category-manage/post-category-manage.component').then(
              (m) => m.PostCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_UPDATE_POST_CATEGORY'],
          },
          canActivate: [PostCategoryGuard(config)],
        },
        {
          path: 'copy/:category',
          loadComponent: () =>
            import('@app/src/app/modules/post/views/admin/category/category-manage/post-category-manage.component').then(
              (m) => m.PostCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_COPY_POST_CATEGORY'],
          },
          canActivate: [PostCategoryGuard(config)],
        },
        {
          path: '**',
          redirectTo: 'list',
          pathMatch: 'full',
        },
      ],
    },
    {
      path: '**',
      redirectTo: 'list',
      pathMatch: 'full',
    },
  ],
});
